import { useGate, useLayer } from '@eventbrite/statsig';
import {
    EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
} from '../../constants/statsig';

export const useIsExpressPaypalExperimentEnabled = (): boolean => {
    const { value } = useLayer(
        EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
        EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
        EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};

export const useIsUrgencySignalsExperimentEnabled = (): boolean => {
    const { value } = useLayer(
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};

export const useIsScrollableCtaExperimentEnabled = (): boolean => {
    const { value } = useLayer(
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};

export const useEnablingExpressWithOptionalQuestionsFeatureGate = () => {
    const { value } = useGate(
        'checkout_enabling_express_with_optional_questions',
    );

    return value === true || value === 'true';
};
